export default function (): void {
  const focusBlockFn = function (this: Element): void {
    this.closest('.search-form__block')?.classList.add('dca-form__field--focused')
  }

  const unfocusBlockFn = function (this: Element): void {
    this.closest('.search-form__block')?.classList.remove('dca-form__field--focused')
  }

  const changeFn = function (el: HTMLInputElement | HTMLSelectElement): void {
    if (el.value === '') {
      el.closest('.search-form__block')?.classList.remove('dca-form__field--filled')
    } else {
      el.closest('.search-form__block')?.classList.add('dca-form__field--filled')
    }
  }

  document.querySelectorAll('.search-form__field').forEach(function (el) {
    el.addEventListener('showDropdown', focusBlockFn)

    el.addEventListener('hideDropdown', function (this: Element) {
      this.closest('.search-form__block')?.classList.remove('dca-form__field--focused')

      changeFn(el as HTMLInputElement | HTMLSelectElement)
    })

    el.addEventListener('clear', () => {
      changeFn(el as HTMLInputElement | HTMLSelectElement)
    })
  })

  document.querySelectorAll('.search-form__list-toggle').forEach(function (el) {
    el.addEventListener('showMenu', focusBlockFn)
    el.addEventListener('hideMenu', unfocusBlockFn)
  })

  document.querySelectorAll('.search-form__list-field').forEach(function (el) {
    el.addEventListener('click', function () {
      if (el.closest('.dca-list')?.querySelectorAll('.search-form__list-field:checked').length === 0) {
        el.closest('.search-form__block')?.classList.remove('dca-form__field--filled')
      } else {
        el.closest('.search-form__block')?.classList.add('dca-form__field--filled')
      }
    })
  })

  if (document.querySelector('.search__form-section form#search-offers')) {
    document.querySelector('.search__form-section form#search-offers')?.addEventListener('submit', function (this: Element) {
      const submitEl = this.querySelector('.search-form__submit')

      if (!submitEl?.classList.contains('submit--loading')) {
        setTimeout(() => {
          submitEl?.classList.add('submit--loading')
        }, 0)

        const submitInputEl = document.getElementById('search_offers_search')

        if (submitInputEl?.hasAttribute('data-loading-message')) {
          submitInputEl.innerText = submitInputEl.getAttribute('data-loading-message') as string
        }
      }
    })
  }
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      // Hide the loader when the page is fetched from bfcache.
      const submitEl = document.body.querySelector('.search-form__submit.submit--loading')
      submitEl?.classList.remove('submit--loading')
    }
  })
}
